import { useEffect, useState } from 'react';

import { Form } from 'antd';
import { PropertyUseCaseInterface } from 'application/usecases/PropertyUseCase';
import FallbackImg from 'assets/images/FallbackImg.svg';
import { ListedPropertyDetailMemberAuctionProperty, ListedPropertyRoomGetAssessmentDetail } from 'domain/entities/PropertyEntity';
import { BUYER_CLASSIFICATION } from 'presentation/components/HeaderRightComponent';
import { openErrorNoti } from 'presentation/components/Notification';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch, useAppSelector } from 'presentation/redux/hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { COMMON } from 'utilities/constants/COMMON';
import { TodoEntity } from '../../CU-002-02/models/CardModel';
import { CollapseDetail } from './components/Collapse';
import { ImageRow } from './components/ImageRow';
import { MarketPrice } from './components/MarketPrice';
import { MarketPriceBuyer } from './components/MarketPriceBuyer';

interface props {
    propertyUseCase: PropertyUseCaseInterface;
    detailAssessment?: ListedPropertyDetailMemberAuctionProperty;
    detailRoomAssessment?: ListedPropertyRoomGetAssessmentDetail;
    type: string;
    currentTodo: TodoEntity;
    bidPrice: number;
    purchaseAmount: number;
}
const TAB1Component = ({
    propertyUseCase,
    detailAssessment,
    detailRoomAssessment,
    type,
    currentTodo,
    bidPrice,
    purchaseAmount,
}: props) => {
    const dispatch = useAppDispatch();
    const [form] = Form.useForm();
    const { listedPropertyId } = useParams();
    const navigate = useNavigate();
    const visibleModalCU01702 = useAppSelector((state) => state.CU01702Slice.isVisibleCU01702);
    const [isBookmarked, setIsBookmarked] = useState<boolean>(false);
    const [countLike, setCountLike] = useState<number>(0);
    const [title, setTitle] = useState<string>('');
    const storedInput = useAppSelector((state) => state.CU03101Slice.storedInput);

    useEffect(() => {
        setCountLike(detailAssessment?.liked || 0);
        setIsBookmarked(detailAssessment?.currentBookmark ?? false);
    }, []);

    useEffect(() => {
        setIsBookmarked(detailAssessment?.currentBookmark ?? false);
        setCountLike(detailAssessment?.liked || 0);
        if (
            detailAssessment?.auctionTime ||
            !detailAssessment?.yourAuctionBid ||
            !detailAssessment.auctionStatus
        ) {
            setTitle('');
        } else {
            let title = '';
            if (!detailAssessment?.auctionTime) {
                title = COMMON.EMPTY;
            } else {
                if (detailAssessment?.auctionTime.days && detailAssessment?.auctionTime.days > 0) {
                    if(detailAssessment?.auctionTime.h > 0){
                        title = '入札締切まであと' + detailAssessment?.auctionTime.days+1 + '日';
                    } else {
                        title = '入札締切まであと' + detailAssessment?.auctionTime.days + '日';
                    }
                } else if (
                    detailAssessment?.auctionTime.days < 1 &&
                    detailAssessment?.auctionTime.h &&
                    detailAssessment?.auctionTime.h > 0
                ) {
                    title = 'あと' + detailAssessment?.auctionTime.h + '時間';
                } else {
                    title = "入札一時停止中";
                }
            }
            setTitle(title);
        }
    }, [detailAssessment]);

    const onclickBookmark = async () => {
        try {
            dispatch(startFetching());
            if (propertyUseCase) {
                const response = await propertyUseCase.memberBookMarkListedProperty({
                    listedPropertyId: Number(listedPropertyId),
                });
                if (response.status == '200') {
                    const likeCount = await propertyUseCase.countLike(Number(listedPropertyId));
                    if (likeCount.status == '200') {
                        setIsBookmarked(!isBookmarked);
                        setCountLike(likeCount.result);
                    }
                }
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const props = {
        currentTodo: currentTodo,
        detailAssessment: detailAssessment,
        isBookmarked: isBookmarked,
        countLike: countLike,
        onClickBookmark: onclickBookmark,
        bidPrice: bidPrice,
        purchaseAmount: purchaseAmount,
    };
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
                paddingLeft: 20,
            }}
        >
            <section
                style={{
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <div className="main-container">
                    <div className="title" style={{ textAlign: 'center' }}>
                        {title}
                    </div>
                    <ImageRow imageURLs={detailAssessment?.images.length >= 1 ? detailAssessment?.images : FallbackImg} />
                    {type == String(BUYER_CLASSIFICATION) ? (
                        <MarketPriceBuyer {...props} />
                    ) : (
                        <MarketPrice {...props} />
                    )}
                    <CollapseDetail detailRoomAssessment={detailRoomAssessment} detailAssessment={detailAssessment} />
                </div>
            </section>
        </div>
    );
};
export default TAB1Component;
